import styled from 'styled-components'

import { MAX_TABLET_WIDTH } from 'src/Styled/variables'

export const ButtonsContainer = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Card = styled.div`
  width: 100%;
`

export const CardBody = styled.div`
  width: 100%;
  @media screen and (min-width: ${MAX_TABLET_WIDTH}) {
    padding: 24px;
  }
`

export const TabTriggersOverflow = styled.div`
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
